import HRLayout from "../hr/HRLayout";
import DashboardTable from "../components/DashboardTable";

export default function DashboardPage() {
  return (
    <HRLayout navMode="dashboard">
      <DashboardTable />
    </HRLayout>
  );
}
